import { render, staticRenderFns } from "./InterventionForm.vue?vue&type=template&id=5db8230e&scoped=true&"
import script from "./InterventionForm.vue?vue&type=script&lang=js&"
export * from "./InterventionForm.vue?vue&type=script&lang=js&"
import style0 from "./InterventionForm.vue?vue&type=style&index=0&id=5db8230e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8230e",
  null
  
)

export default component.exports